"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.createDeepEqualSelector = void 0;
exports.genKeyedSelector = genKeyedSelector;
exports.immutableSelectorCreator = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));
var _immutable = _interopRequireDefault(require("immutable"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _reselect = require("reselect");
const immutableSelectorCreator = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _immutable.default.is);
exports.immutableSelectorCreator = immutableSelectorCreator;
const createDeepEqualSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _isEqual.default);
exports.createDeepEqualSelector = createDeepEqualSelector;
function genKeyedSelector(selectorGeneratorFn, keyConverter = key => key) {
  // This takes a selector generator function and returns an object that will
  // create a new selector on request for a given key or returns the previous
  // one for that key if it already exist.
  return {
    _selectors: new _map.default(),
    get(key) {
      key = keyConverter(key);
      if (!this._selectors.has(key)) {
        this._selectors.set(key, selectorGeneratorFn());
      }
      return this._selectors.get(key);
    },
    run(operand, key = operand) {
      // Usually we want to get the ouput of the selector and the key is usually
      // the selector's operand possibly transformed by the key converter
      // function.
      return this.get(key)(operand);
    }
  };
}